import { useAuth } from "./context/AuthContext";
import { Navigate, Outlet } from "react-router";
import useProfile from './customHooks/useProfile';
import { useState, useEffect } from "react";

const VerificationRoute = () => {
    const { email, userVerified } = useAuth();
    const { checkProfileStatus } = useProfile();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const validate = async () => {
            if (!email) return setLoading(false);

            await checkProfileStatus();
            setLoading(false);
        };
        validate();
    }, [email]);

    if (loading) return <div>Loading...</div>;

    if (!email) return <Navigate to="/login" />;

    if (userVerified !== "PENDING") {
        if (userVerified === "IN_REVIEW") return <Navigate to="/profilepending" />;
        if (userVerified === "VERIFIED") return <Navigate to="/" />;
    }

    return <Outlet />;
};

export default VerificationRoute;